import React from 'react';

import { uiRoutes } from '@consumer-frontend/api';
import { dateFromTimestamp } from '@consumer-frontend/shared';
import { Link, ListGroupItem } from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/index.scss';
import '@consumer-bootstrap/pages/account-home/message-center.scss';

export type CnuMessageCenterLinkPropsT = {
  messageDate: string;
  messageTitle: string;
  onClick?: () => void;
};

export type CnuMessageCenterLinkT = React.FC<CnuMessageCenterLinkPropsT>;

export const CnuMessageCenterLink: CnuMessageCenterLinkT = ({
  messageTitle,
  messageDate,
  onClick,
}) => {
  const date = dateFromTimestamp(messageDate);
  const datetime = new Date(date).toISOString().slice(0, 10);

  return (
    <ListGroupItem>
      <Link
        className="cnu-message-center-link"
        data-piiMask
        onClick={onClick}
        to={uiRoutes.messageDetail}
      >
        {messageTitle}
      </Link>

      <time className="cnu-message-date" data-chromatic="ignore" data-piiMask dateTime={datetime}>{date}</time>
    </ListGroupItem>
  );
};
